import { render } from "./UploadTile.vue?vue&type=template&id=529bbfc6&ts=true"
import script from "./UploadTile.vue?vue&type=script&lang=ts"
export * from "./UploadTile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__